import React from "react";
import { useLocation } from "react-router-dom";
import "./nav.css";
import Service from "./service";

function Goback() {
  return (
    <div className="back" onClick={() => (window.location.href = "/")}>
      <img
        src={
          require("../../Assets/img/misc/GO BACK - ServiceDetailsToLandingPage - original.png")
            .default
        }
        alt="back"
      />
      <span>GO BACK</span>
    </div>
  );
}

function Nav(props) {
  const search = useLocation().search;
  const URLid = new URLSearchParams(search).get("id");
  return (
    <div
      onClick={(event) => {
        event.stopPropagation();
      }}
      className="nav-block"
    >
      {/* <div className="nav-bar">
        <Navbar services={props.services} mainContent={props.mainContent} />
      </div> */}
      <div className="nav">
        {props.services.map((service, i) => {
          return (
            <Service
              id={service.id}
              key={i}
              title={service.title}
              mainContent={props.mainContent}
              categoryChange={props.categoryChange}
              category={service.title}
              urlId={URLid}
            />
          );
        })}
      </div>
      <Goback />
    </div>
  );
}

export { Goback };
export default Nav;
